import { useState } from 'react';
import type { MediaItem } from '@/types';
import SectionHeading from '@/components/base/SectionHeading';
import MovieCard from '@/components/base/MovieCard';

interface FeaturedGridProps {
  items: MediaItem[];
}

const TABS = [
  { key: 'all', label: '热门推荐' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
];

export default function FeaturedGrid({ items }: FeaturedGridProps) {
  const [tab, setTab] = useState('all');

  const filtered = items
    .filter((item) => tab === 'all' || item.type === tab)
    .sort((a, b) => b.hot - a.hot)
    .slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100/60">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <span className="w-1 h-6 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
              热门影视作品
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">
              影迷正在追的高分作品
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-200/70 border border-background-300/50 self-start sm:self-auto">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`px-4 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                tab === t.key
                  ? 'bg-accent-500 text-background-50 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3 md:gap-5">
        {filtered.map((item, index) => (
          <MovieCard key={item.id} item={item} rank={tab === 'all' ? index + 1 : undefined} />
        ))}
      </div>
    </section>
  );
}